module.exports = __webpack_public_path__ + "img/blog-cv-4.45480478.webp";